import { buildModelManager } from "../builder.js";
const DefaultCampaignEmailSettingsSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  createdAt: true,
  emailSettings: true,
  emailTemplateId: true,
  providerConfigurationId: true,
  shopId: true,
  updatedAt: true
};
const modelApiIdentifier = "campaign_email_settings";
const pluralModelApiIdentifier = "campaign_email_settingss";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultCampaignEmailSettingsSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createCampaignEmailSettings",
    operationReturnType: "CreateCampaignEmailSettings",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      campaign_email_settings: { required: false, type: "CreateCampaignEmailSettingsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignEmailSettingsSelection
  },
  {
    type: "action",
    operationName: "bulkCreateCampaignEmailSettings",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkCreateCampaignEmailSettingsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignEmailSettingsSelection
  },
  {
    type: "action",
    operationName: "updateCampaignEmailSettings",
    operationReturnType: "UpdateCampaignEmailSettings",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      campaign_email_settings: { required: false, type: "UpdateCampaignEmailSettingsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignEmailSettingsSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateCampaignEmailSettings",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpdateCampaignEmailSettingsInput!]"
      }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultCampaignEmailSettingsSelection
  },
  {
    type: "action",
    operationName: "deleteCampaignEmailSettings",
    operationReturnType: "DeleteCampaignEmailSettings",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteCampaignEmailSettings",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertCampaignEmailSettings",
    operationReturnType: "UpsertCampaignEmailSettings",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      campaign_email_settings: { required: false, type: "UpsertCampaignEmailSettingsInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateCampaignEmailSettingsResult": { hasReturnType: false },
      "... on UpdateCampaignEmailSettingsResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultCampaignEmailSettingsSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertCampaignEmailSettings",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: {
        required: true,
        type: "[BulkUpsertCampaignEmailSettingsInput!]"
      }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultCampaignEmailSettingsSelection
  }
];
const CampaignEmailSettingsManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultCampaignEmailSettingsSelection,
  operations
);
export {
  CampaignEmailSettingsManager,
  DefaultCampaignEmailSettingsSelection
};
//# sourceMappingURL=CampaignEmailSettings.js.map
